module.exports = __webpack_public_path__ + "static/img/zp_17.725dcf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zp_17.png
// module id = EVwm
// module chunks = 4